// Helpers puros para a página HydraConfig.

/** Formata timestamp ISO em pt-BR ("01/05/2026 14:32:10"). Vazio vira em-dash. */
export const fmtDateTime = (s: string | null): string =>
  s ? new Date(s).toLocaleString('pt-BR') : '—';
